import { ENVIRONMENT, SECOND_IN_MILLISECONDS } from '../constants';

export const MAX_FILE_SIZE_PER_REQUEST = 2.0e6;
export const INITIAL_TEST_PART_SIZE = MAX_FILE_SIZE_PER_REQUEST / 4; // ~500k
export const MAX_PARALLEL_UPLOAD_REQUESTS = ENVIRONMENT.MAX_PARALLEL_REQUESTS;
export const IDEAL_PER_PART_UPLOAD_TIME_MAX_SECONDS = 90;

export const calculateSpeedKbps = (timeInMilliseconds, fileSize) => {
  const durationInSeconds = timeInMilliseconds / SECOND_IN_MILLISECONDS;
  const bytesPerSecond = fileSize / durationInSeconds;
  return bytesPerSecond / 1024;
};
